import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-car-description',
  templateUrl: './car-description.component.html',
  styleUrls: ['./car-description.component.scss']
})
export class CarDescriptionComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  driveWarning:string = '';
  showDriveWarning:boolean = false;
  carDescription:any;

  canPop:boolean = false;

  constructor(
    private initializationservice:InitializationService, 
    private navigationservice:NavigationService,
    private route: ActivatedRoute,
    private customerservice : CustomerService,
    public alertDialog: MatDialog,
    private router: Router,
    private currentinfoservice: CurrentInfoService,
    private currentorderservice: CurrentOrderService,
    private localeservice: LocaleService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.carDescription = this.currentorderservice.getCarDescription();
  }

  canReturn()
  { 
    if(this.canPop === true)
      return true;

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
      return true;

    return new Promise<boolean>((resolve, reject) =>
    {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Cancel")  
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        resolve(result);
      });
    });
  }

  back()
  {
    this.navigationservice.back();
  }

  checkFields()
  {
    var hasError = this.carDescription.Reference === '' || this.carDescription.Reference === undefined;
    hasError = this.carDescription.Model === '' || this.carDescription.Model === undefined;
    hasError = this.carDescription.Color === '' || this.carDescription.Color === undefined;
    
    if(hasError === true)
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Accept") 
        }
      });

      return false;
    }

    return true;
  }

  goOn()
  {
    if(this.checkFields())
    {
      this.currentorderservice.setCarDescription(this.carDescription);

      this.canPop = true;

      var appname = String(this.route.snapshot.paramMap.get('appname'));
            
      this.router.navigateByUrl('/' + appname + '/orderbasedata');
    }
  }
}
